import { render, staticRenderFns } from "./MaidPayment.vue?vue&type=template&id=70485c32&"
import script from "./MaidPayment.vue?vue&type=script&lang=js&"
export * from "./MaidPayment.vue?vue&type=script&lang=js&"
import style0 from "./MaidPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidPayment.vue"
export default component.exports